module.exports = __webpack_public_path__ + "static/media/nike-never-ask.4ba0acdb.jpg";